
const prefix = 'message';
module.exports.EVENTS_MESSAGE = {
  CREATED: `${prefix}.created`,
  MESSAGES_READ: `${prefix}.messages_read`,
  RATING_SELECTED: `${prefix}.rating_selected`,
  MESSAGE_UPDATED: `${prefix}.message_updated`,
}; 